import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useLocation } from "react-router-dom";
import AppBar from "../../common/AppBar";
import { deleteUnit, fetchAllUnits } from "../../redux/unitSlice";
import { AuditTrailForExport } from "../../util/getAuditTrailData";
import { BASE_URL } from "../../config";
import AppTable from "../../common/AppTable/AppTable";
import { showSnackbar } from "../../redux/snackbarSlice";
import ReactSelect from "../../common/ReactSelect/ReactSelect";
import { PrimaryButton, OutlineButton } from "../../common/Buttons";
import { EditRowButton, DeleteRowButton } from "../../common/Buttons/TableButtons";

const columnNames = [
  { headName: "Unit Type", field: "unit_type_name", sort: true, filter: true },
  { headName: "Units", field: "unit_name", filter: true,width: "350px" },
  { headName: "Action", field: "action", isAction:true}];

const Units = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const { units, pagination } = useSelector((state) => state.units);

  const [limit, setLimit] = useState(10);
  const [offset, setOffset] = useState(0);
  const tableContainerRef = useRef();
  const [searchQuery, setSearchQuery] = useState("");
  const [refreshKey, setRefreshKey] = useState(0);

  const snackbar = (message,type) => {
    dispatch(showSnackbar({type:type,message:message}))
  }

  const handleSaveClick = () => {
    navigate("/add-unit");
  };

  const handleDelete = async(unitId) => {
   await dispatch(deleteUnit(unitId));
   snackbar("Unit type deleted successfully.","success")
   dispatch(fetchAllUnits({searchQuery: searchQuery || ""})).then(() => {
     setRefreshKey(prev => prev + 1);
   });
  };

  const handleExportCSV = async () => {
    await AuditTrailForExport({
      apiUrl: `${BASE_URL}unit-tpyes/export-data`,
      file_name: "unit-type-data-" + Date.now() + ".csv",
      action: "EXPORT_UNIT_TYPE_DATA",
      action_to_show: "Unit Type Table data exported as CSV",
    });
  };

  // Fetch data when searchQuery changes
  useEffect(()=>{
    if (location.pathname === "/units") {
      dispatch(fetchAllUnits({searchQuery: searchQuery || ""})).then(() => {
        // Increment refreshKey to force ReactSelect components to remount
        setRefreshKey(prev => prev + 1);
      });
    }
  },[dispatch, searchQuery, location.pathname])

  const contentAfterHeader = <div style={{textAlign:"right", marginTop:"-30px", marginBottom:"8px"}}><PrimaryButton onClick={handleSaveClick}>Create Unit Type</PrimaryButton></div>
  const paginationLeftContent = <OutlineButton
            variant="outline-blue"
            style={{
              marginLeft: "-1px",
              marginTop: "10px",
            }}
            onClick={handleExportCSV}
          >
            Export CSV
          </OutlineButton>
  return (
    <div>
      <AppBar title="Unit Types" showBlackTitle={true} moveToDirectoryScreen={true} buttons={[]} showTablesDropdown={false} />
     
      <AppTable 
        ref={tableContainerRef}
            columnsData={columnNames}
            showSearchInput={true}
            paginate={true}
            pagination={{
              limit: [limit, setLimit],
              offset: [offset, setOffset],
              pagination,
              paginationPosition:{
                position:"right",
                leftContent:paginationLeftContent
              }
            }}
            extrapadding="0px"
            onFilterSortHandler={setSearchQuery}
            contentAfterHeader={contentAfterHeader}
      >
        {units?.map((row) => {
          const options = row?.unit_type_for_name?.map((u) => ({isDisabled: true, value: u.unit_name, label: u.unit_name+``+(u.is_default_unit_for_type?` (Default)`:""), default:u.is_default_unit_for_type }));
          const defaultOption = options?.find(o => o.default) || options?.[0];
          // Create a unique key that includes refreshKey to force re-render when data is fetched
          // This ensures ReactSelect remounts with fresh data when returning from UnitForm
          const selectKey = `${row.unit_type_id}-${refreshKey}`;

          return <tr key={row.unit_type_id}>
            <td>{row.unit_type_name}</td>
            <td>
            <ReactSelect 
              key={selectKey}
              options={options} 
              defaultValue={defaultOption} 
              otherProps={{isClearable:false}} 
            />
          </td>
          <td style={{width:"100px"}}>
            <div className="app-action-btns">
              <EditRowButton
                onClick={() =>
                  navigate("/add-unit", {
                    state: { editMode: true, unit: row },
                  })
                }
              />
              <DeleteRowButton
                disabled={row.used_in_part}
                onClick={() => handleDelete(row.unit_type_id)}
              />
            </div>
          </td>
        </tr>
      })}
      </AppTable>
    </div>
  );
};

export default Units;
